import { faEye } from "@fortawesome/free-solid-svg-icons";

const columnsMoviments = [
  { key: "number", label: "Número" },
  { key: "type", label: "Tipo" },
  { key: "customer", label: "Cliente" },
  { key: "movement_date", label: "Data do movimento", align: "center" },
];

const actionsMoviments = (navigate, canAccess) => [
  {
    id: "details",
    icon: faEye,
    title: "Ver Detalhes do Movimento",
    buttonClass: "btn-info",
    permission: "Ver movimentos",
    onClick: (movementItem) => {
      navigate(`/aluguel/movimentos/detalhes/${movementItem.movement.id}`);
    },
    show: (movementItem) =>
      !movementItem.movement.isDeleted && canAccess("Ver movimentos"),
  },
];

export { columnsMoviments, actionsMoviments };
